module.exports = "<p>\r\n  customer-address-listing works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/customer-address-listing/customer-address-listing.component.html
// module id = ./src/app/customer-address-listing/customer-address-listing.component.html
// module chunks = main